const scrollTo = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full min-h-screen flex items-end pb-16 sm:pb-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/efc3695965e714b3d01e411b892ac5b4.jpg"
          alt="Dreamline Bridal - Custom Luxury Wedding Gown"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/20 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl animate-fade-in-up">
          <p
            className="text-xs tracking-widest uppercase text-amber-200/90 mb-3 sm:mb-5"
            style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.22em' }}
          >
            CUSTOM Luxury Wedding Gowns
          </p>
          <h1
            className="text-3xl sm:text-5xl lg:text-7xl text-white mb-4 sm:mb-7"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, letterSpacing: '-0.01em', lineHeight: 1.1 }}
          >
            Your Dream Gown,<br />
            <em style={{ fontStyle: 'italic', fontWeight: 400 }}>Made just for you</em>
          </h1>
          <p
            className="text-sm sm:text-base text-white/80 mb-6 sm:mb-10 max-w-md leading-relaxed"
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Share your vision. We'll craft a one-of-a-kind wedding gown, tailored to your measurements and shipped to your door.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={() => scrollTo('#consultation')}
              className="whitespace-nowrap px-8 sm:px-10 py-3.5 sm:py-4 bg-white text-stone-900 text-xs tracking-widest uppercase cursor-pointer hover:bg-stone-100 transition-all duration-300 rounded-sm"
              style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.14em' }}
            >
              Begin Your Journey
            </button>
            <button
              onClick={() => scrollTo('#how-it-works')}
              className="whitespace-nowrap px-8 sm:px-10 py-3.5 sm:py-4 border border-white/60 text-white text-xs tracking-widest uppercase cursor-pointer hover:bg-white/10 transition-all duration-300 rounded-sm"
              style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.14em' }}
            >
              How It Works
            </button>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-5 sm:gap-10 mt-8 sm:mt-16 pt-6 sm:pt-10 border-t border-white/20">
          {[
            { number: '300', label: 'Brides Dressed' },
            { number: '100%', label: 'Custom Made' },
            { number: '5-Mo', label: 'Avg. Process' },
            { number: '★ 5.0', label: 'Average Rating' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span
                className="text-xl sm:text-2xl text-amber-200"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500, letterSpacing: '0.02em' }}
              >
                {stat.number}
              </span>
              <span
                className="text-xs text-white/60 mt-1 tracking-widest uppercase"
                style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.14em' }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-12 hidden sm:flex flex-col items-center gap-3 opacity-60">
        <span
          className="text-white/60 text-xs tracking-widest uppercase rotate-90"
          style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.18em', fontSize: '0.6rem' }}
        >
          Scroll
        </span>
        <div className="w-px h-12 bg-white/40" />
      </div>
    </section>
  );
}
